import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false


new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)  
})



// WEBPACK FOOTER //
// ./src/main.js